import React from 'react';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle, faMinusCircle} from '@fortawesome/free-solid-svg-icons'

const Wrapper = styled.span`
    input[type=number] {
        border: none;
        user-select: none;
        outline: none;
        max-width: 30px;
        text-align: center;
        line-height: 16px;
    }
    svg {
        cursor: pointer;
        &:hover {
          color: ${({theme}) => theme.colors.blue};
        }
    }
`;

const QuantitySelector = ({quantity, setQuantity}) => {
  return (
    <Wrapper>
        <FontAwesomeIcon icon={faMinusCircle} onClick={ev => setQuantity(Math.max(1, quantity - 1))}/>
        <input type="number" value={quantity} onChange={ev => setQuantity(ev.target.value)}/>
        <FontAwesomeIcon icon={faPlusCircle} onClick={ev => setQuantity(quantity + 1)}/>
    </Wrapper>
  )
};

export default QuantitySelector;

      